import { configureStore } from "@reduxjs/toolkit";
import loginReducer from "./authSlice";
import clientSlice from "./clientSlice";
import fieldsSlice from "./fieldsSlice";
import inspectionSlice from "./inspectionSlice";
import lookupSlice from "./lookupSlice";
import modalSlice from "./modalSlice";
import notificationSlice from "./notificationSlice";
import surveyReducer from "./surveySlice";
import templateSlice from "./templateSlice";
import userSlice from "./userSlice";

export const store = configureStore({
  reducer: {
    survey: surveyReducer,
    login: loginReducer,
    inspection: inspectionSlice,
    lookup: lookupSlice,
    fields: fieldsSlice,
    client: clientSlice,
    modal: modalSlice,
    user: userSlice,
    template: templateSlice,
    notification: notificationSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
